var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollegeSearchWelcomeModalImage2 = function SvgCollegeSearchWelcomeModalImage2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 317 152"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "college-search-welcome-modal-image-2_svg__b",
    width: 292.78,
    height: 148.357,
    x: 1.273,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "college-search-welcome-modal-image-2_svg__c",
    width: 39.587,
    height: 39.301,
    x: 12.641,
    y: 44.849,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "college-search-welcome-modal-image-2_svg__d",
    width: 39.587,
    height: 39.301,
    x: 12.641,
    y: 98.946,
    rx: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.533 10)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#college-search-welcome-modal-image-2_svg__b",
    fill: "#000",
    filter: "url(#college-search-welcome-modal-image-2_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#college-search-welcome-modal-image-2_svg__b",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#3AC162",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 13,
    fontWeight: 500,
    transform: "translate(10.533 10)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.958,
    y: 67.172
  }, "$200")), /*#__PURE__*/React.createElement("text", {
    fill: "#929FAA",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 13,
    fontWeight: 500,
    transform: "translate(10.533 10)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 228.232,
    y: 119
  }, "$8,000")), /*#__PURE__*/React.createElement("path", {
    fill: "#43C975",
    d: "m237.56 65.022-6.131 6.956h3.503v6.087h5.256v-6.087h3.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41BF66",
    d: "M10.533 46.989h294.053v54.559H10.533z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.475 70.107)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121.953,
    height: 4.432,
    y: 48.086,
    fill: "#DBE4EB",
    rx: 2.216
  }), /*#__PURE__*/React.createElement("rect", {
    width: 137.876,
    height: 4.432,
    x: 0.109,
    fill: "#929FAA",
    rx: 2.216
  }), /*#__PURE__*/React.createElement("rect", {
    width: 76.099,
    height: 4.432,
    y: 57.333,
    fill: "#DBE4EB",
    rx: 2.216
  }), /*#__PURE__*/React.createElement("rect", {
    width: 86.035,
    height: 4.432,
    x: 0.109,
    y: 9.247,
    fill: "#929FAA",
    rx: 2.216
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBE4EB",
    d: "M11.93 46.99h293"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#929FAA",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 2.182,
    transform: "translate(10.533 10)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.109,
    y: 24.021
  }, "FOLLOWING")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#college-search-welcome-modal-image-2_svg__c",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.587,
    height: 38.301,
    x: 13.141,
    y: 45.349,
    stroke: "#DBE4EB",
    rx: 12
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#college-search-welcome-modal-image-2_svg__d",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.587,
    height: 38.301,
    x: 13.141,
    y: 99.446,
    stroke: "#DBE4EB",
    rx: 12
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E0FD",
    d: "M22.641 66.853c0-6.63 5.377-12.004 11.997-12.004H50.36c6.626 0 11.997 5.366 11.997 12.004v12.04H22.64zm0 54.097c0-6.63 5.377-12.004 11.997-12.004H50.36c6.626 0 11.997 5.366 11.997 12.004v12.04H22.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3AC162",
    fillOpacity: 0.5,
    d: "M22.641 75.656h39.68v3.237h-39.68zm-.465 54.097h40.053v3.237H22.176z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M42.304 58.548c2.3 0 4.284 1.35 5.19 3.297h-10.38a5.72 5.72 0 0 1 5.19-3.297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54F00",
    d: "M0 17.126h35.626V7.034H0z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54F00",
    d: "M0 17.126h17.813V7.034H0z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE6A00",
    d: "M11.979 4.082h11.633v-.835H11.979z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54F00",
    d: "M11.979 4.082h5.847v-.835H11.98z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE6A00",
    d: "M14.03 7.106h.941v-.373h-.94zm-.423.43h.942v-.373h-.942z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F4ED",
    d: "M20.016 10.675c-.01-.87-1.015-1.572-2.253-1.572s-2.243.702-2.253 1.572v.34h4.506z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DCCD",
    d: "M19.4 10.411c-.007-.517-.731-.935-1.625-.935-.893 0-1.618.418-1.625.935v.202h3.25z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F4ED",
    d: "M19.401 15.892h.614v-5.009H19.4z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424E5B",
    d: "M16.105 15.855h3.316v-4.84h-3.316z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F4ED",
    d: "M15.51 15.932h.613v-5.008h-.614z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DCCD",
    d: "M29.069 14.828h1.514V7.986H29.07zm3.653 0h1.514V7.986h-1.514zm-27.699 0h1.514V7.986H5.023zm-3.591 0h1.515V7.986H1.432zM0 17.379h35.626v-1.746H0z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F4ED",
    d: "M13.406 15.932h.85v-7.97h-.85zm7.842-.203h.85V7.962h-.85zm-11.142.169h.85V7.962h-.85zM24.66 15.7h.85V7.962h-.85z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939FA9",
    d: "M30.036 4.082H17.812v2.952h17.814z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424E5B",
    d: "M5.59 4.082h12.223v2.952H0z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DCCD",
    d: "M10.114 7.962h15.405v-.973H10.114z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F4ED",
    d: "M17.812 4.082 10.106 6.99h15.413z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DCCD",
    d: "M14.639 3.096h-.876v-.69c0-.164.134-.297.3-.297h.276c.166 0 .3.133.3.298zm2.249 0h-.876v-.69c0-.164.134-.297.3-.297h.276a.3.3 0 0 1 .3.298zm2.713 0h-.876v-.69c0-.164.135-.297.3-.297h.277a.3.3 0 0 1 .3.298v.689zm2.084 0h-.876v-.69c0-.164.134-.297.3-.297h.276c.166 0 .3.133.3.298z",
    mask: "url(#college-search-welcome-modal-image-2_svg__f)",
    transform: "translate(24.504 58.548)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M28.547 130.086h8.54v-11.339h-8.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEBC6E",
    d: "M28.547 130.086h4.278v-11.339h-4.278z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9E4C0",
    d: "M28.397 130.086h8.698v-3.047h-8.698z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M29.173 129.357h6.914v-1.732h-6.914z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M35.563 129.357H36.6v-1.732h-1.037zM28.23 119.14h8.872v-.393H28.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7D781",
    d: "M28.23 119.14h8.872v-.393H28.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M46.533 130.086h8.54v-11.339h-8.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEBC6E",
    d: "M46.533 130.086h4.278v-11.339h-4.278z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9E4C0",
    d: "M46.383 130.086h8.699v-3.047h-8.699z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M47.16 129.357h7.027v-1.732H47.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M53.55 129.357h1.036v-1.732H53.55zm-7.334-10.217h8.872v-.393h-8.872z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7D781",
    d: "M46.216 119.14h8.872v-.393h-8.872z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBEBC0",
    d: "M29.18 123.922h1.036v-1.732H29.18zm1.597 2.405h1.036v-1.732h-1.036zm4.792-2.405h1.037v-1.732h-1.037zm-4.792-2.242h1.036v-1.732h-1.036zm16.303 4.647h1.037v-1.732H47.08zm4.793 0h1.037v-1.732h-1.037zm-4.793-4.647h1.037v-1.732H47.08zm4.793 0h1.037v-1.732h-1.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M36.325 130.085h10.982v-16.282H36.325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7D781",
    d: "M36.325 130.085h10.982v-16.281H36.325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAE181",
    d: "M41.795 124.021h5.491v-10.217h-5.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBEBC0",
    d: "M36.325 130.085h10.982v-6.064H36.325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF0C0",
    d: "M41.823 130.06h5.492v-6.033h-5.492z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBEBC0",
    d: "M37.305 123.255h.92v-1.473h-.92zm0-4.556h.92v-1.474h-.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M44.566 113.769h-5.501a2.746 2.746 0 0 1 2.75-2.741 2.745 2.745 0 0 1 2.751 2.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7D781",
    d: "M44.55 113.76h-2.724l-.027-2.74a2.745 2.745 0 0 1 2.751 2.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBEBC0",
    d: "M43.594 113.54h-3.557c0-.979.796-1.772 1.779-1.772s1.778.793 1.778 1.772m-.214 9.715h.92v-1.473h-.92zm2.026-2.26h.92v-1.474h-.92zm0-4.556h.92v-1.474h-.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M36.062 113.803H47.57v-.25H36.062zm5.704 11.723c-.648 0-1.173.48-1.173 1.073v3.487h2.347V126.6c0-.593-.525-1.073-1.174-1.073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424E5B",
    d: "M42.663 126.754H40.87c0-.493.4-.893.896-.893.495 0 .897.4.897.893m-1.794 3.332h1.776v-3.013h-1.776z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M44.942 125.526c-.648 0-1.173.48-1.173 1.073v3.487h2.347V126.6c0-.593-.526-1.073-1.174-1.073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424E5B",
    d: "M45.839 126.754h-1.794c0-.493.402-.893.897-.893s.897.4.897.893m-1.794 3.332h1.776v-3.013h-1.776z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C981",
    d: "M38.638 125.526c-.648 0-1.173.48-1.173 1.073v3.487h2.346V126.6c0-.593-.525-1.073-1.173-1.073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424E5B",
    d: "M39.534 126.754h-1.793c0-.493.402-.893.897-.893s.896.4.896.893m-1.794 3.332h1.776v-3.013H37.74z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.956 70.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.206,
    height: 19.921,
    fill: "#5586F8",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.649 4.465h-4.843v2.623h1.017v5.824H8.006V7.088h1.017V4.465H4.18v2.623h1.186v6.72l1.976 1.964h5.144l1.976-1.963v-6.72h1.186z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.956 124.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.206,
    height: 19.921,
    fill: "#14CCE6",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.649 4.465h-4.843v2.623h1.017v5.824H8.006V7.088h1.017V4.465H4.18v2.623h1.186v6.72l1.976 1.964h5.144l1.976-1.963v-6.72h1.186z"
  })))));
};
export default SvgCollegeSearchWelcomeModalImage2;